<div class="cs-d-flex flex-column h-100">
    <div class="cs-flex-1 cs-common-ui--container">
        <div class="p-20">
            <div class="cs-common-ui--panel cs-d-flex flex-column cs-common-ui--panel--background">
                <div class="cs-panel-header">
                    <div class="cs-d-flex">
                        <div class="cs-h3" translate>Basic.Details.Title</div>
                    </div>
                </div>

                <div class="cs-common-ui--panel-content">
                    <form class="no-form-style" novalidate [formGroup]="form">
                        <div class="cs-block-widget--form cs-d-flex flex-column">
                            <div class="cs-block-widget--form-control-scale-2">
                                <label class="control-label required_field" translate>Automation name</label>
                                <div>
                                    <input formControlName="name" type="text" class="m-b-0" style="width: 732px">
                                </div>
                            </div>

                            <div class="cs-block-widget--form-control-scale-2">
                                <label class="control-label" translate>Description</label>
                                <div>
                                    <textarea formControlName="description" style="width: 732px" rows="5"></textarea>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="cs-common-ui--cs-step-actions">
        <div class="cs-actions cs-d-flex h-100">
            <button  (click)="closeFullScreenModal()" class="btn btn-link ml-auto">
                <span>Back</span>
            </button>
            <button [disabled]="form.invalid || isSaving" (click)="save()" class="btn btn-primary save_btn">
                <span>Continue</span>
            </button>
        </div>
    </div>
</div>
